var _rect, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithubRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 51,
    width: 57,
    height: 62,
    fill: "url(#pattern0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 155,
    height: 155,
    rx: 77.5,
    stroke: "#FA382F",
    strokeWidth: 5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_16_102",
    transform: "scale(0.0175439 0.016129)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_16_102",
    width: 57,
    height: 62,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAA+CAYAAACRHbM9AAAFI0lEQVRoBd1a23ETMRR1CZSQEvheicGfWRkGOog7SDqADqAD3AF0EHcAHcAHeM1X3IGZI62c3dW5etjOZk1mMrJl6d577ktXj9ks8fcwn7/Y1urT1uiHxui9/a/1Pfp+m+plYvrZf4Y8zULdbIz+ujHqp5dpa/T3v/Wr90cxBDFPiLVgtDX6FsyPYpA5qbmeXzVGfWEy9Pre6HkmSTfMas1bL9HC0gAbY9C8ffWa/l/Pr6R52eBa+TZGfZNo0f7GVMuelhJAMdZZtnr311QfoHm4US4NGxJtKMAlHY02RDJ4gw9oUDBSJ7SSK+CUxhXFZi/ZHDSpdlMBtDH6F5Plj9EfJcMF/YzAxlSfEaubhbrbGP2DjXnaPrVrarVq2gTDeEHGAAzrkJLOUEtgJmmUCXBSX61WwyzemGod0qzWDFPQB+HDyXov+TvANyZ0ZWvtWq3wuxtTLS1t0IeCFuqu89tapCEsDU8CEkIFGmk7Dm68UHcAII1L9WPZgDK9UmLjTwIJwsyS2f4ek+yMv/HkmOmuDmToflj3zijjSaRQVjJDwAOyCMP1uJb0PovACIOcO5NioVarLPY2TR/Wxi4htcsiMMKgaEWWyglSZoVrZLvCCCDBQlqrk2EllXPFxe8IQF1chrkDBpGWu5mr+rvu6T+r3XAhHgFDFgssaywBNbW+pwSkYJ6amw6Fl6ouahi+uOo9HTzk9IzfJWtSl+XLRsHi+kxApTALihdYi/n21F3V65W77MBA8tJRLT2hKbc81HJBphbWiSBnIHEc0xNPtORFg9Q/skDSDNWbOY0vzJLo60knZahLSTz8ZHAAEohZdg3ScE810/nCZA8sCXF5wUu0MR1sVpIiL2TFOQqEiWEKxJG2XTTU0EnNPvEMK+5/mdzSkcKU4xKVGi9HIxt8Xh7pPfw+8JMJdEjeF93/wmrUZXPPTkYELltR76PHolKmcsCnVcdiY8wMglUiqWvRmrFjhSTV8w6IXcpmVWlu28XPTqA5XKefV+R8avA0Xt24o5poLA7ZSGuPdw97Z79QN8N5T/XdhVH8Sh1JEwYqkkE6VvBA0Vqw9la5elfMICFNa7VbKfa6cuCy6OjHGuJCSw+fW9C1vrfX4WwxFoC1mfLWxpqQUPqg/Eki2hMAenlSriszB+j0pWhrscdnNIICGR+4aNSCVnvtOx0EcywrgRAv4LsaFT4nColYNmfAfB/mJUOEuWJUK3Y7Vi3FqkiwQIom2xh4ILyt1tHF3rsgWlbzoS9mUT8fY5yS5KUGAkIhfo7UWlqCgjxIq9harVIKC3jE3S+/uonFbK5QsjWrNWI2ED63QypuvfZyLApeEki6nxOEQ2yxMDjLfjZmTevOGVoU19OMuV3MYgIqpNOlefgsEkecSLdDh9mz9jasH5tF5VVLS4zNgvW2I1b4UXI567oZTBB7AOYTRDK1hyLMRjn7ZUuKBZlhTSJzcdcoIKF99mAIQHOTUDGyzoRRQIKflERsEspw247MxR9HAwnJJGvCovY180Ld2Ae6eFHcPtbdGvfO9ZSXzKOClKxp4zNRmWAMrD7ZxNP1L36BIhTgBHhJIeD5jmpJMG0rkBPetJZfL4wO8hGocERJrNd35wsBeXCj6/kVqiJWW/aBdd35wkB6sGjtgZJ99FstEXf45+AvGGQXsP/Mk9R/BpIV+FiGvBJK2nCNVruT9pMlzGNjXTn4+Oj9mB2Ip+8yrN/RoM3fvHsaT9pC48cUAUyo3BMFNrfb9w/vvWgyNbDdEAAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubRed);
export default __webpack_public_path__ + "static/media/githubRed.62eb76767e410df1b3270a8a3ca4b272.svg";
export { ForwardRef as ReactComponent };